import axios from 'axios';

export default {
    namespaced: true,
    state: {
        all: [],
        categories: [],
        rotations: [],
    },
    getters: {
        getAllCouplings(state) {
            return state.all;
        },
        getAllCategories(state) {
            return state.categories;
        },
        getAllRotations(state) {
            return state.rotations;
        }
    },
    actions: {
        index({commit}) {
            return axios.all([
                axios.get(process.env.VUE_APP_API_URL + 'couplings')
                    .then(({data}) => {
                        commit('setCouplings', data);
                    }),
                axios.get(process.env.VUE_APP_API_URL + 'coupling_categories')
                    .then(({data}) => {
                        commit('setCouplingCategories', data);
                    }),
                axios.get(process.env.VUE_APP_API_URL + 'rotations')
                    .then(({data}) => {
                        commit('setRotations', data);
                    }),
            ]);
        },
    },
    mutations: {
        setCouplings(state, couplings) {
            state.all = couplings;
        },
        setCouplingCategories(state, categories) {
            state.categories = categories;
        },
        setRotations(state, rotations) {
            state.rotations = rotations;
        },
    },
};
